import { css } from '@emotion/css';
import { useTranslation } from '@miotech/shared';

const FallbackError = () => {
  const { W2 } = useTranslation(['common']);

  return <div className={cssFallbackError}>{W2('common:pageLoadError')}</div>;
};

export default FallbackError;

export const cssFallbackError = css`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
